// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v2.0.10-0-g1be495e",
    "hash": "g1be495e",
    "distance": 0,
    "tag": "v2.0.10",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.0.10",
        "major": 2,
        "minor": 0,
        "patch": 10,
        "prerelease": [],
        "build": [],
        "version": "2.0.10"
    },
    "suffix": "0-g1be495e",
    "semverString": "2.0.10",
    "version": "2.0.10"
};
